module.exports = __webpack_public_path__ + "img/container_rear_right.085a1a05.svg";